import {
    HomeDemo3IcoPlatforms1,
    HomeDemo3IcoPlatforms2,
    HomeDemo3IcoPlatforms3,
    HomeDemo3IcoPlatforms4,
    HomeDemo3IcoPlatforms5,
    HomeDemo3IcoPlatforms6,

    HomeDemo3Services1,
    HomeDemo3Services2,
    HomeDemo3Services3,
    HomeDemo3Services4,
    HomeDemo3Services5,
    HomeDemo3Services6,

    HomeDemo3TokenIcon1,

    HomeDemo3TeamImg1,
    HomeDemo3TeamImg2,
    HomeDemo3TeamImg3,
    HomeDemo3TeamImg4,
    HomeDemo3TeamImg5,
    
    
    HomeDemo3Partners1,
    HomeDemo3Partners2,
    HomeDemo3Partners3,
    HomeDemo3Partners4,
    HomeDemo3Partners5,
    HomeDemo3Partners6,
    HomeDemo3Partners7,
    HomeDemo3Partners8,
    HomeDemo3Partners9,
    HomeDemo3Partners10,
    HomeDemo3Partners11,
    HomeDemo3Partners12,

    HomeDemo3RoadmapIcons1,
    HomeDemo3RoadmapIcons2,
    HomeDemo3RoadmapIcons3,
    HomeDemo3RoadmapIcons4,
    HomeDemo3RoadmapIcons5,
    HomeDemo3RoadmapIcons6,
    HomeDemo3RoadmapIcons7,
    HomeDemo3RoadmapIcons8,
    HomeDemo3RoadmapIcons9,

    HomeDemo3BlogImg1,
    HomeDemo3BlogImg2,
    HomeDemo3BlogImg3

} from '../../utils/allImgs'

export const VerticalSocial = [
    {nameIco:'fa-brands fa-telegram', link: 'https://t.me/databeast_ai'},
    {nameIco:'fa-brands fa-discord', link:'https://discord.com/invite/6uBjGKSU5G'},
    {nameIco:'fa-brands fa-facebook', link:'https://www.facebook.com/databeast_ai'},
    {nameIco:'fa-brands fa-twitter', link:'https://twitter.com/databeast_ai'},
    {nameIco:'fa-brands fa-instagram', link:'https://www.instagram.com/databeast_ai'},
    
]

export const HowItWorksInfo = [
    {step:1 , title:"Crypto & Blockchain AI", description:"Gain deeper insights into market trends with our AI-driven predictions, offering a clear path through the digital currency landscape.", url:"crypto-detail"},
    {step:2 , title:"Real Estate AI", description:"Unlock the potential of the real estate market with cutting-edge AI analysis, providing strategic insights into market dynamics, property valuations, and investment opportunities.", url:"realestate-detail"},
    {step:3 , title:"Sports Analytics", description:"Transform the game with predictive insights that give teams, coaches, and sports organizations a competitive edge.", url:"sports-detail"},
    
]
export const SingleCoolFact = [
    {
        img:HomeDemo3IcoPlatforms1,
        ico_check:true
    },
    {
        img:HomeDemo3IcoPlatforms2,
        ico_check:false
    },
    {
        img:HomeDemo3IcoPlatforms3,
        ico_check:true
    },
    {
        img:HomeDemo3IcoPlatforms4,
        ico_check:true
    },
    {
        img:HomeDemo3IcoPlatforms5,
        ico_check:false
    },
    {
        img:HomeDemo3IcoPlatforms6,
        ico_check:true
    }
]

export const service_single_content = [
    {
        img:HomeDemo3Services1,
        title:'Smart Trading Modules'
    },
    {
        img:HomeDemo3Services2,
        title:'Adaptive Social Assistant'
    },
    {
        img:HomeDemo3Services3,
        title:'Analyzer of the News '
    },
    {
        img:HomeDemo3Services4,
        title:'Exchange Order Management'
    },
    {
        img:HomeDemo3Services5,
        title:'Module of Price Notification'
    },
    {
        img:HomeDemo3Services6,
        title:'Crypto Trading Platform'
    }

]

// export const timelineInfo = [
//     {
//         left:"20%",
//         ClassName:"data_cir cir_0",
//         date:"Q2 2024",
//         IsSpan:true,
//         TextSpan:"Whitepaper release ",
//         IsTowLi:false,
//         TextTowLi1:"",
//         TextTowLi2:"",
//         IsThreeLi:false,
//         TextThreeLi1:"",
//         TextThreeLi2:"",
//         TextThreeLi3:"",
//         IsFourLi:false,
//         TextFourLi1:"",
//         TextFourLi2:"",
//         TextFourLi3:"",
//         TextFourLi4:"",
//         img:HomeDemo3RoadmapIcons1

//     },
//     {
//         left:"40%",
//         ClassName:"data_cir cir_1",
//         date:"Q3 2024",
//         IsSpan:false,
//         TextSpan:"",
//         IsTowLi:false,
//         TextTowLi1:"",
//         TextTowLi2:"",
//         IsThreeLi:false,
//         TextThreeLi1:"",
//         TextThreeLi2:"",
//         TextThreeLi3:"",
//         IsFourLi:true,
//         TextFourLi1:"Token release on multiple platforms(Base,Ton and Runes)",
//         TextFourLi2:"Early adaptor program and referral program",
//         TextFourLi3:"Release of the crypto LLM(beta)on Bitcoin and Runes data.",
//         TextFourLi4:" Dev and Release of the Real Estate LLM",
//         img:HomeDemo3RoadmapIcons2

//     },
//     {
//         left:"60%",
//         ClassName:"data_cir cir_2",
//         date:"Q4 2024",
//         IsSpan:false,
//         TextSpan:"",
//         IsTowLi:true,
//         TextTowLi1:"Expand Crypto LLM to other blockchains",
//         TextTowLi2:"Partner with Sports clubs",
//         TextTowLi3:"Dev and Release of the Sports LLM",
//         TextTowLi4:"Dev and Release of the Fitness LLM",
//         TextTowLi5:"Refine Roadmap for 2025",
//         IsThreeLi:false,
//         TextThreeLi1:"",
//         TextThreeLi2:"",
//         TextThreeLi3:"",
//         IsFourLi:false,
//         TextFourLi1:"",
//         TextFourLi2:"",
//         TextFourLi3:"",
//         TextFourLi4:"",
//         img:HomeDemo3RoadmapIcons3

//     },
//     {
//         left:"80%",
//         ClassName:"data_cir cir_3",
//         date:"Q1 2025",
//         IsSpan:false,
//         TextSpan:"",
//         IsTowLi:false,
//         TextTowLi1:"",
//         TextTowLi2:"",
//         IsThreeLi:true,
//         TextThreeLi1:"Model Refinements ,Customizations.",
//         TextThreeLi2:"Additional industry Partnerships",
//         TextThreeLi3:"Launch of Travel AI LLM",
//         TextThreeLi3:"5-year strategy for Databeast AI",
//         TextThreeLi4:"Many more possibilities....",
//         IsFourLi:false,
//         TextFourLi1:"",
//         TextFourLi2:"",
//         TextFourLi3:"",
//         TextFourLi4:"",
//         img:HomeDemo3RoadmapIcons4

    // },
    // {
    //     left:"50%",
    //     ClassName:"data_cir cir_4 red_c",
    //     date:"Q2 2018",
    //     IsSpan:false,
    //     TextSpan:"",
    //     IsTowLi:false,
    //     TextTowLi1:"",
    //     TextTowLi2:"",
    //     IsThreeLi:true,
    //     TextThreeLi1:"Crowdsale",
    //     TextThreeLi2:"marketing campaign",
    //     TextThreeLi3:"listing to the major exchanges",
    //     IsFourLi:false,
    //     TextFourLi1:"",
    //     TextFourLi2:"",
    //     TextFourLi3:"",
    //     TextFourLi4:"",
    //     img:HomeDemo3RoadmapIcons5

    // },
    // {
    //     left:"60%",
    //     ClassName:"data_cir cir_5 next",
    //     date:"Q3 2018",
    //     IsSpan:false,
    //     TextSpan:"",
    //     IsTowLi:false,
    //     TextTowLi1:"",
    //     TextTowLi2:"",
    //     IsThreeLi:true,
    //     TextThreeLi1:"Crypto Wallet version release",
    //     TextThreeLi2:"Testnet launch",
    //     TextThreeLi3:" Platform ealier version development",
    //     IsFourLi:false,
    //     TextFourLi1:"",
    //     TextFourLi2:"",
    //     TextFourLi3:"",
    //     TextFourLi4:"",
    //     img:HomeDemo3RoadmapIcons6

    // },
    // {
    //     left:"70%",
    //     ClassName:"data_cir cir_6 next",
    //     date:"Q4 2018",
    //     IsSpan:false,
    //     TextSpan:"",
    //     IsTowLi:false,
    //     TextTowLi1:"",
    //     TextTowLi2:"",
    //     IsThreeLi:true,
    //     TextThreeLi1:"Mobile App",
    //     TextThreeLi2:"Explorer",
    //     TextThreeLi3:"new partnerships and new marketplace support",
    //     IsFourLi:false,
    //     TextFourLi1:"",
    //     TextFourLi2:"",
    //     TextFourLi3:"",
    //     TextFourLi4:"",
    //     img:HomeDemo3RoadmapIcons7

    // },
    // {
    //     left:"80%",
    //     ClassName:"data_cir cir_7 next",
    //     date:"Q1 2019",
    //     IsSpan:false,
    //     TextSpan:"",
    //     IsTowLi:false,
    //     TextTowLi1:"",
    //     TextTowLi2:"",
    //     IsThreeLi:true,
    //     TextThreeLi1:"Mainnet launch",
    //     TextThreeLi2:"Wallet beta-version release",
    //     TextThreeLi3:"Masternodes implementation",
    //     IsFourLi:false,
    //     TextFourLi1:"",
    //     TextFourLi2:"",
    //     TextFourLi3:"",
    //     TextFourLi4:"",
    //     img:HomeDemo3RoadmapIcons8

    // },
    // {
    //     left:"90%",
    //     ClassName:"data_cir cir_8 next",
    //     date:"Q2 2019",
    //     IsSpan:false,
    //     TextSpan:"",
    //     IsTowLi:true,
    //     TextTowLi1:"Platform integration to electronic marketplaces",
    //     TextTowLi2:"Zero Fee",
    //     IsThreeLi:false,
    //     TextThreeLi1:"",
    //     TextThreeLi2:"",
    //     TextThreeLi3:"",
    //     IsFourLi:false,
    //     TextFourLi1:"",
    //     TextFourLi2:"",
    //     TextFourLi3:"",
    //     TextFourLi4:"",
    //     img:HomeDemo3RoadmapIcons9

    // }
// ]
export const timelineInfo = [
    {
        timelineClass:"block block-left",
        title:'Q2 2024',
        date_from:'April, 2024',
        date_to:'June, 2024',
        text:['Whitepaper release', 'Release of the Crypto LLM(testnet)on bitcoin and Runes data','Community building','Seed Round Investments','Smart contract development','Establish Key Partnership']
    },
    {
        timelineClass:"block block-right mt-30",
        title:'Q3 2024',
        date_from:'July, 2024',
        date_to:'September, 2024',
        text:['Token launch on multiple platforms(Base,Ton and Runes)','Easy adaptor program and referral program','Release of the Crypto LLM(Beta)on bitcoin and Runes data','Dev and Release of the Real Estate LLM',]
    },
    {
        timelineClass:"block block-left mt-30",
        title:'Q3 2024',
        date_from:'October 2024',
        date_to:'December 2024',
        text:['Expant Crypto LLM to other Blockchains', 'Partner with Sports Clubs','Dev and Release of the Sports LLM','Dev and Release of the Fitness LLM','Refine Roadmap for 2025',]
    },
    {
        timelineClass:"block block-right mt-30",
        title:'2025',
        date_from:'January',
        date_to:'December',
        text:['Model Requirements,Customizations','Additional Industry Partnerships','Launch of Travel AI LLM','5-year strategy for Databeast AI','Many more possibilities',]
    }
]

export const ServiceBlock = [
    
    {
        classIco:"icon ti-settings",
        title:"Telecom",
        description: "Generative AI is transforming telecom by optimizing network traffic, predicting equipment failures, preventing fraud, personalizing customer experiences.",
        url: "telecom-detail"
    },
    {
        classIco:"icon ti-settings",
        title:"Agriculture",
        description:"Generative AI is revolutionizing agriculture by predicting crop yields, pests, and diseases, optimizing breeding, enabling precision farming, controlling machinery, simulating weather.",
        url:"agriculture-detail"
    },
    {
        classIco:"icon ti-settings",
        title:"Marketing",
        description:"Generative AI is transforming marketing with influencer targeting, customer profiling, personalized content, and campaign optimization.",
        url:"marketing-detail"
    },
    {
        classIco:"icon ti-settings",
        title:"Fitness",
        description:"Generative AI personalizes fitness with custom plans, AI coaches, progress tracking, nutrition, and engaging workouts.",
        url:"fitness-detail"
    },
    


]

export const SocialListIco = [
    {icoName:"fa fa-facebook-square"},
    {icoName:"fa fa-twitter-square"},
    {icoName:"fa fa-instagram"},
    {icoName:"fa fa-discord"},
]

export const FQAInfo = [
    {
        text:'What are the objectives of this token?',
        ID:'Q1'
    },
    {
        text:'What is Token Sale and pre-sale?',
        ID:'Q2'
    },
    {
        text:'What is the pre-sale start date?',
        ID:'Q3'
    },
    {
        text:'how may I take part in pre-sale?',
        ID:'Q4'
    },
]

export const DocElementTitle = [
    {
        title:'WhitePaper'
    },
    {
        title:'OnePager'
    },
    {
        title:'Rating Review'
    },
    {
        title:'Marketing Plan'
    },
]

export const TokenText = [
    {
        text: 'TOTAL Quantity: 10,000,000,000',
        img:HomeDemo3TokenIcon1
    },
    {
        text:'35% Presale',
        img:HomeDemo3TokenIcon1
    },
    {
        text:'15% Liquidity',
        img:HomeDemo3TokenIcon1
    },
    {
        text:'5% Airdrop to Community',
        img:HomeDemo3TokenIcon1
    },
    {
        text:'5% Partners and Advisors',
        img:HomeDemo3TokenIcon1
    },
    {
        text:'15% Marketing',
        img:HomeDemo3TokenIcon1
    },
    {
        text:'15% Team and Seed',
        img:HomeDemo3TokenIcon1
    },
    {
        text:'10% Reserved for Future Developments',
        img:HomeDemo3TokenIcon1
    },



]

export const MissionData = [
    {
        icoName:"ti-shine",
        title:"Quality"
    },
    {
        icoName:"ti-ruler-pencil",
        title:"Creativity"
    },
    {
        icoName:"ti-heart",
        title:"Reliability"
    },
]

export const TeamMember = [
    {
        img:HomeDemo3TeamImg1,
        title:'Hanumantha Marakanti',
        text:'CEO| FOUNDER'
    },
    {
        img:HomeDemo3TeamImg2,
        title:'Vinay Kumar',
        text:'Chief Architect and Principal AI Engineer'
    },
    {
        img:HomeDemo3TeamImg3,
        title:'Srikanth A',
        text:'Chief Strategist'
    },
    {
        img:HomeDemo3TeamImg4,
        title:'Bhaskar G',
        text:'Chief Technology Officer'
    },
    {
        img:HomeDemo3TeamImg5,
        title:'Kishore Y',
        text:'Data Architect'
    },
   
]

export const PartnersData = [
    {img:HomeDemo3Partners1},
    {img:HomeDemo3Partners2},
    {img:HomeDemo3Partners3},
    {img:HomeDemo3Partners4},
    {img:HomeDemo3Partners5},
    {img:HomeDemo3Partners6},
    {img:HomeDemo3Partners7},
    {img:HomeDemo3Partners8},
    {img:HomeDemo3Partners9},
    {img:HomeDemo3Partners10},
    {img:HomeDemo3Partners11},
    {img:HomeDemo3Partners12}
]

export const BlogPost = [
    {img:HomeDemo3BlogImg1},
    {img:HomeDemo3BlogImg2},
    {img:HomeDemo3BlogImg3}
]
